import React, { useEffect, useState } from 'react';
import { Modal, Button, Table, Tag, Typography, Popconfirm, Row, Col, notification } from 'antd';
import { CheckCircleOutlined, CheckOutlined, CloseOutlined, EuroCircleOutlined, CopyOutlined, SyncOutlined, CloseCircleOutlined, QuestionCircleOutlined, StopOutlined } from '@ant-design/icons';
import '../../css/AutoPoolDetailsModal.css';
import cbgreenIcon from "../../assets/icons/pooling/cb-green.svg";
import cbredIcon from "../../assets/icons/pooling/cb-red.svg";
import euroCurrencyIcon from "../../assets/icons/pooling/euroCurrency.svg";
import { useSelector } from 'react-redux';
import ClipboardJS from 'clipboard';

const addThousandSeparator = (value) => {
  const number = parseFloat(value);

  if (isNaN(number)) {
    return '';
  }

  return number.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 20,
  });
};


const { Text } = Typography;

const AutoPoolDetailsModal = ({ poolId, setAdminAction, adminAction, userRole, handlePoolRequest, notification_status, PoolDetailsData, isVisible, onClose, setIsPoolDetailsModalOpen }) => {

  const surplusCount = PoolDetailsData?.filter(item => item.pool_agent_type === "surplus").length;
  const deficitCount = PoolDetailsData?.filter(item => item.pool_agent_type === "deficit").length;

  const sum_of_cb_positive = PoolDetailsData?.reduce((sum, item) =>
    item.cb_wants_to_sell > 0 ? sum + item.cb_wants_to_sell : sum, 0);

  const sum_of_cb_negative = PoolDetailsData?.reduce((sum, item) =>
    item.cb_wants_to_sell < 0 ? sum + item.cb_wants_to_sell : sum, 0);

  const sum_of_remaining_cb = PoolDetailsData?.reduce((sum, item) =>
    item.remaining_balance ? sum + item.remaining_balance : sum, 0);


  const tokenIdList = PoolDetailsData?.reduce((list, item) => {
    if (item.is_my_vessel && !list.includes(item.token_id)) {
      return [...list, item.token_id]; // Add token_id if not already present
    }
    return list;
  }, []);

  let allApproved = PoolDetailsData?.filter(item => item.is_my_vessel)
    .every(item => item.status.toLowerCase() == "pending" && item.current_status == "active");

  useEffect(() => {
    allApproved = PoolDetailsData?.filter(item => item.is_my_vessel)
      .every(item => item.status.toLowerCase() == "pending" && item.current_status == "active");

  }, [PoolDetailsData])

  let allAdminApproved = PoolDetailsData.every(item => item.is_approved_by_admin == false && item.current_status == "active_ad");

  if (allAdminApproved) {
    setAdminAction(true);
  }

  useEffect(() => {
    allAdminApproved = PoolDetailsData.every(item => item.is_approved_by_admin == false && item.current_status == "active_ad");
    if (allAdminApproved) {
      setAdminAction(true);
    }
  }, [PoolDetailsData])

  const { user } = useSelector((state) => state.user);


  // Copy to Clipboard function
  const copyToClipboard = (text) => {
    // Create a temporary button for Clipboard.js to bind
    const tempButton = document.createElement('button');
    tempButton.style.opacity = '0'; // Hide the button
    tempButton.style.position = 'fixed'; // Prevent UI shift
    document.body.appendChild(tempButton);

    // Initialize Clipboard.js
    const clipboard = new ClipboardJS(tempButton, {
      text: () => text,
    });

    clipboard.on('success', () => {
      notification.success({
        message: 'Copied',
        description: 'The content has been copied to clipboard.',
      });
      clipboard.destroy();
      document.body.removeChild(tempButton);
    });

    clipboard.on('error', () => {
      notification.error({
        message: 'Copy failed',
        description: 'Failed to copy the content.',
      });
      clipboard.destroy();
      document.body.removeChild(tempButton);
    });

    // Programmatically trigger a click to activate Clipboard.js
    tempButton.click();
  };


  const columns = [
    {
      title: <span style={{ fontWeight: '400', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Token ID</span>,
      dataIndex: 'tokenId',
      key: 'tokenId',
      width: 150,
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {text}
          <button
            style={{
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
            onClick={() => copyToClipboard(text)}
          >
            <CopyOutlined style={{ marginLeft: 8 }} />
          </button>
        </div>
      ),
    },

    // {
    //   title: <span style={{ fontWeight: '400' }}>Vessel Name</span>,
    //   dataIndex: 'vesselName',
    //   key: 'vesselName',
    //   width:130,
    // },
    // ...(user.role === "Admin Pooling Agent" ? [
    //   {
    //     title: <span style={{ fontWeight: '400' }}>Brokerage (%)</span>,
    //     dataIndex: 'broker_percentage',
    //     key: 'broker_percentage',
    //     align: 'center',
    //     width: 100,
    //   },
    // ] : []),
    {
      title: <span style={{ fontWeight: '400' }}>Vessel Name</span>,
      dataIndex: 'vesselName',
      key: 'vesselName',
      width: 110,
      render: (text, record) => (user.role === "Admin Pooling Agent" ? text : record.is_my_vessel ? text : <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>-</div>), // Show only if is_my_vessel is true
    },
    {
      title: <span style={{ fontWeight: '400' }}>Total C.B. <br />(MT CO<sub>2</sub>e)</span>,
      dataIndex: 'cb_wants_to_sell',
      key: 'cb_wants_to_sell',
      align: 'center',
      width: 155,
      render: (balance) => (
        <Text style={{
          display: 'flex',
          justifyContent: 'center',
          color: balance >= 0 ? '#0CC876' : '#c80c0c'
        }}>
          {balance >= 0 ? (
            <div className='flex' style={{ display: "flex", alignItems: "center", justifyContent: "left" }}>
              {/* <img src={cbgreenIcon} alt="CB green" /> */}
              {addThousandSeparator(Math.abs(balance))}
            </div>
          ) : (
            <div className='flex' style={{ display: "flex", alignItems: "center", justifyContent: "left" }}>
              {/* <img src={cbredIcon} alt="CB red" /> */}
              {addThousandSeparator(Math.abs(balance))}
            </div>
          )}
        </Text>
      ),
    },
    {
      title: <span style={{ fontWeight: '400' }}>Contributed C.B. <br />(MT CO<sub>2</sub>e)</span>,
      dataIndex: 'contribution',
      key: 'contribution',
      align: 'center',
      width: 155,
      render: (balance) => (
        <Text style={{
          display: 'flex',
          justifyContent: 'center',
          color: balance >= 0 ? '#0CC876' : '#c80c0c'
        }}>
          {balance >= 0 ? (
            <div className='flex' style={{ display: "flex", alignItems: "center", justifyContent: "left" }}>
              {/* <img src={cbgreenIcon} alt="CB green" /> */}
              {addThousandSeparator(Math.abs(balance))}
            </div>
          ) : (
            <div className='flex' style={{ display: "flex", alignItems: "center", justifyContent: "left" }}>
              {/* <img src={cbredIcon} alt="CB red" /> */}
              {addThousandSeparator(Math.abs(balance))}
            </div>
          )}
        </Text>
      ),
    },
    {
      title: <span style={{ fontWeight: '400' }}>Remaining C.B. <br />(MT CO<sub>2</sub>e)</span>,
      dataIndex: 'remaining_balance',
      key: 'remaining_balance',
      align: 'center',
      width: 155,
      render: (balance) => (
        <Text style={{
          display: 'flex',
          justifyContent: 'center',
          color: balance >= 0 ? '#0CC876' : '#c80c0c'
        }}>
          {balance >= 0 ? (
            <div className='flex' style={{ display: "flex", alignItems: "center", justifyContent: "left" }}>
              {/* <img src={cbgreenIcon} alt="CB green" /> */}
              {addThousandSeparator(Math.abs(balance))}
            </div>
          ) : (
            <div className='flex' style={{ display: "flex", alignItems: "center", justifyContent: "left" }}>
              {/* <img src={cbredIcon} alt="CB red" /> */}
              {addThousandSeparator(Math.abs(balance))}
            </div>
          )}
        </Text>
      ),
    },
    {
      title: <span style={{ fontWeight: '400' }}>Compensation <br />(€)</span>,
      dataIndex: 'settledAt',
      key: 'settledAt',
      align: 'center',
      width: 130,
      render: (balance, row) => (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          color: balance >= 0 ? '#0CC876' : '#c80c0c'
        }}>
          {balance >= 0 ? (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              {user.role === "Admin Pooling Agent" ? addThousandSeparator(Math.abs(balance)) : row.is_my_vessel ? addThousandSeparator(Math.abs(balance)) : '-'}
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              {user.role === "Admin Pooling Agent" ? addThousandSeparator(Math.abs(balance)) : row.is_my_vessel ? addThousandSeparator(Math.abs(balance)) : '-'}
            </div>
          )}
        </div>
      ),
    },
    ...(user.role === "Admin Pooling Agent" ? [
      {
        title: <span style={{ fontWeight: '400' }}>Brokerage <br />(%)</span>,
        dataIndex: 'brokerage',
        key: 'brokerage',
        align: 'center',
        width: 100,
      },
    ] : []),
    {
      title: <span style={{ fontWeight: '400' }}>Status</span>,
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      width: 180,
      render: (_, row) => {
        return (
          <Button
            className={`pooling-notification-status-button-details pooling-notification-button ${row.status == 'pending' ? 'pooling-notification-blue' : row.status == 'approved' ? 'pooling-notification-green' : 'pooling-notification-red'}`}
            style={{ pointerEvents: "none" }}
            // onClick={() => console.log("filter.value")}
          >
            {row.status.charAt(0)?.toUpperCase() + row.status.slice(1)}
          </Button>

        );
      },
    },
    ...(user.role == "Pooling Agent" ? [{
      title: <span style={{ fontWeight: '400' }}>Vessel Ownership</span>,
      dataIndex: 'is_my_vessel',
      key: 'is_my_vessel',
      align: 'center',
      width: 160,
      render: (text) => (
        <Text style={{ display: 'flex', justifyContent: "center", alignItems: "center" }}>
          {text ? "Owned by Me" : ""}
        </Text>
      ),
    }] : []),
    // ,
    // {
    //   title: <span style={{ fontWeight: '400' }}>Savings (€)</span>,
    //   dataIndex: 'savings',
    //   key: 'savings',
    //   align: 'center',
    //   width: 130,
    //   render: (balance) => (
    //     <div style={{ display:'flex',
    //     justifyContent:'center',
    //     color: '#678DFF' }}>
    //      {addThousandSeparator(balance)}
    //     </div>
    //   ),    
    // }    
  ];

  // Data source - combining surplus and deficit data  
  const dataSource = [
    ...PoolDetailsData?.filter(item => item?.pool_agent_type === "surplus" ?? []).map((item, index) => ({
      key: `surplus-${index}`,
      tokenId: item?.token_id,
      vesselName: item?.vessel_name,
      contribution: (Math.floor(item?.contribution / 10 ** 6 * 1000000) / 1000000).toFixed(6),
      settledAt: (Math.floor(item?.amount)).toFixed(4),
      surplusDeficit: item?.pool_agent_type,
      status: item?.status,
      current_status: item?.current_status,
      cb_wants_to_sell: (Math.floor(item?.cb_wants_to_sell / 10 ** 6 * 1000000) / 1000000).toFixed(6),
      remaining_balance: (Math.floor(item?.remaining_balance / 10 ** 6 * 1000000) / 1000000).toFixed(6),
      is_my_vessel: item?.is_my_vessel,
      ...(user.role === "Admin Pooling Agent" ? { brokerage: item?.brokerage?.toFixed(2) } : {}),
    })),
    ...PoolDetailsData?.filter(item => item?.pool_agent_type === "deficit" ?? []).map((item, index) => ({
      key: `deficit-${index}`,
      tokenId: item?.token_id,
      vesselName: item?.vessel_name,
      contribution: (Math.floor(item?.contribution / 10 ** 6 * 1000000) / 1000000).toFixed(6),
      settledAt: (Math.floor(item?.amount)).toFixed(4),
      surplusDeficit: item?.pool_agent_type,
      status: item?.status,
      current_status: item?.current_status,
      cb_wants_to_sell: (Math.floor(item?.cb_wants_to_sell / 10 ** 6 * 1000000) / 1000000).toFixed(6),
      remaining_balance: (Math.floor(item?.remaining_balance / 10 ** 6 * 1000000) / 1000000).toFixed(6),
      is_my_vessel: item?.is_my_vessel,
      ...(user.role === "Admin Pooling Agent" ? { brokerage: item?.brokerage?.toFixed(2) } : {}),
    }))
  ].sort((a, b) => a.tokenId - b.tokenId);



  const handleCopyPoolId = () => {
    copyToClipboard(poolId); // Copy Pool ID
  };

  const getRowClassName = (record) => {
    return record.surplusDeficit == 'surplus' ? 'surplus-row' : 'deficit-row';
  };

  return (
    <div className="pool-details-modal">
      <Modal
        onCancel={onClose}
        open={isVisible}
        width={1300}
        centered
        className="pool-details-modal-antd z-1000"
        closable={true} // Adds the default close button (X)
        footer={null}  // Removes OK and Cancel buttons
      >
        <div className="modal-header">
          <Row justify="space-between" align="middle">
            <Col style={{ flex: 1 }}>
              <div>
                <Text strong>Pool Details ({surplusCount + deficitCount} Vessels)</Text>
              </div>
              <div>
                {notification_status == "approved" || notification_status == "Admin Approved" ?
                  <Tag icon={<CheckCircleOutlined />} color="success">
                    {notification_status.charAt(0) + notification_status.slice(1)}
                  </Tag>
                  : notification_status == "Pending" || notification_status == "Pending Admin" ?
                    <Tag icon={<SyncOutlined spin />} color="blue">
                      {notification_status.charAt(0) + notification_status.slice(1)}
                    </Tag>
                    :
                    <Tag icon={<CloseCircleOutlined />} color="error">
                      {notification_status.charAt(0) + notification_status.slice(1)}
                    </Tag>


                }
              </div>
            </Col>

            <Col style={{ marginRight: '10px' }}>
              <div className={`total-cb-transasction-header ${sum_of_cb_positive >= 0 ? "green" : "red"}`}>
                <span style={{ fontSize: "15px" }}>Total Surplus CB</span>
                <div className={`total-cb-transasction ${sum_of_cb_positive >= 0 ? "auto-green" : "auto-red"}`}>
                  {sum_of_cb_positive >= 0 ? <img width={30} height={30} src={cbgreenIcon} /> : <img width={30} height={30} src={cbredIcon} />}
                  {sum_of_cb_positive >= 0 ? "" + addThousandSeparator(Math.abs((Math.floor(sum_of_cb_positive / 10 ** 6 * 1000000) / 1000000)).toFixed(4)) : addThousandSeparator(Math.abs((Math.floor(sum_of_cb_positive / 10 ** 6 * 1000000) / 1000000)).toFixed(4))} CB
                </div>
              </div>
            </Col>
            <Col style={{ marginRight: '10px' }}>
              <div className={`total-cb-transasction-header ${sum_of_cb_negative >= 0 ? "green" : "red"}`}>
                <span style={{ fontSize: "15px" }}>Total Deficit CB</span>
                <div className={`total-cb-transasction ${sum_of_cb_negative >= 0 ? "auto-green" : "auto-red"}`}>
                  {sum_of_cb_negative >= 0 ? <img width={30} height={30} src={cbgreenIcon} /> : <img width={30} height={30} src={cbredIcon} />}
                  {sum_of_cb_negative >= 0 ? "" + addThousandSeparator(Math.abs((Math.floor(sum_of_cb_negative / 10 ** 6 * 1000000) / 1000000)).toFixed(4)) : addThousandSeparator(Math.abs((Math.floor(sum_of_cb_negative / 10 ** 6 * 1000000) / 1000000)).toFixed(4))} CB
                </div>
              </div>
            </Col>
            <Col style={{ marginRight: '10px' }}>
              <div className={`total-cb-transasction-header ${sum_of_remaining_cb >= 0 ? "green" : "red"}`}>
                <span style={{ fontSize: "15px" }}>Total Remaining CB</span>
                <div className={`total-cb-transasction ${sum_of_remaining_cb >= 0 ? "auto-green" : "auto-red"}`}>
                  {sum_of_remaining_cb >= 0 ? <img width={30} height={30} src={cbgreenIcon} /> : <img width={30} height={30} src={cbredIcon} />}
                  {sum_of_remaining_cb >= 0 ? "" + addThousandSeparator(Math.abs((Math.floor(sum_of_remaining_cb / 10 ** 6 * 1000000) / 1000000)).toFixed(4)) : addThousandSeparator(Math.abs((Math.floor(sum_of_remaining_cb / 10 ** 6 * 1000000) / 1000000)).toFixed(4))} CB
                </div>
              </div>
            </Col>


            <Col style={{ marginRight: '10px' }}>
              {/* <div className='total-amount'>
                <img width={30} height={30} src={euroCurrencyIcon} />
                {addThousandSeparator(((Math.floor(sum_of_price  * 10000) / 10000)).toFixed(4))}
              </div> */}
            </Col>
          </Row>
        </div>

        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={false}
          className="pool-details-table"
          scroll={{ y: 300 }}
          rowClassName={getRowClassName} // Apply conditional styling to rows
        />

        <div className="modal-footer">
          <div className="pool-id-container">
            <Text>Pool ID: {poolId}</Text>
            <button
              style={{
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center'
              }}
              onClick={handleCopyPoolId}
            >
              <CopyOutlined style={{ marginLeft: 8 }} />
            </button>
          </div>

          {allApproved && user.role == "Pooling Agent" ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: '2vw', gap: "1vw" }}>
            <Popconfirm
              className='auto-pool-pop-confirm'
              placement="top"
              title="Accept Pool Request!"
              description="Do you really want to accept this request?"
              okText="Yes"
              okButtonProps={{ style: { lineHeight: "1", fontWeight: "500" } }}
              cancelText="Cancel"
              onConfirm={() => handlePoolRequest(tokenIdList, poolId, 'approved')}
            >
              <Button
                className='pooling-notification-status-button pooling-notification-green pooling-notification-button'
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: "1vw" }}
                icon={<CheckOutlined />}
              >
                Accept
              </Button>
            </Popconfirm>
            <Popconfirm
              title="Decline Pool Request!"
              description="Are you sure to decline this pool?"
              className='auto-pool-pop-confirm'
              icon={
                <QuestionCircleOutlined
                  style={{
                    color: 'red',
                  }}
                />
              }
              okText="Yes"
              okButtonProps={{ style: { lineHeight: "1", fontWeight: "500" } }}
              onConfirm={() => handlePoolRequest(tokenIdList, poolId, 'decline')}
            >
              <Button
                className='pooling-notification-status-button pooling-notification-red pooling-notification-button'
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: "1vw" }}
                icon={<CloseOutlined />}
              >
                Decline
              </Button>
            </Popconfirm>
          </div> : adminAction && user.role == 'Admin Pooling Agent' && notification_status == 'Pending Admin' ?
            <div className='pooling-notifications-footer-container'>
              <Popconfirm
                placement="top"
                title="Accept Pool Request!"
                description="Do you really want to accept this request?"
                okText="Yes"
                cancelText="Cancel"
                okButtonProps={{ style: { lineHeight: "1", fontWeight: "500" } }}
                onConfirm={() => { handlePoolRequest("", poolId, 'approved'); setIsPoolDetailsModalOpen(false); }}
              >
                <Button
                  key={poolId}
                  className='pooling-notification-status-button pooling-notification-green pooling-notification-button'
                  icon={<CheckOutlined />}
                >
                  Accept
                </Button>
              </Popconfirm>

              <Popconfirm
                title="Decline Pool Request!"
                description="Are you sure to decline this pool?"
                icon={
                  <QuestionCircleOutlined
                    style={{
                      color: 'red',
                    }}
                  />
                }
                okButtonProps={{ style: { lineHeight: "1", fontWeight: "500" } }}
                okText="Yes"
                onConfirm={() => { handlePoolRequest("", poolId, 'decline'); setIsPoolDetailsModalOpen(false); }}
              >
                <Button
                  key={poolId}
                  className='pooling-notification-status-button pooling-notification-red pooling-notification-button'
                  // onClick={() => console.log("filter.value")}
                  icon={<StopOutlined />}
                >
                  Decline
                </Button>
              </Popconfirm>
            </div>
            // : item.is_approved_by_admin==true?
            // <div className='pooling-notifications-footer-container'>
            //     <p className='pooling-notifications-footer-admin-mail'>Accepted by <span>{item.accepted_by}</span></p>
            // </div>
            // :item.is_approved_by_admin==false?
            // <div className='pooling-notifications-footer-container'>
            //     <p className='pooling-notifications-footer-admin-mail'>Declined by <span>{item.accepted_by}</span></p>
            // </div>
            : ""
          }

        </div>
      </Modal>
    </div>
  );
};

export default AutoPoolDetailsModal;
